import { useGetAdminAdvisoryOrganizations } from '@ijoin/hooks';

/* the list endpoint pages at 25 by default, and every org must be selectable */
const ORGANIZATION_LIMIT = 500;

export const useAdvisoryOrganizationOptions = (enabled = true) =>
  useGetAdminAdvisoryOrganizations(
    { sort: 'name', take: ORGANIZATION_LIMIT },
    {
      query: {
        enabled,
        select: res =>
          res.data.map(o => ({
            label: o.name ?? o.advisoryOrganizationId,
            value: o.advisoryOrganizationId
          }))
      }
    }
  );
